module.exports = {
    topHead: {
        select_option_category: "Category",
        select_option_category_holder: "You can enter Title keywords or product links to search",
        select_option_brand: "Brand",
        select_option_brand_holder: "Please select",
        select_option_postKeyWords: "PostKeywords",
        select_option_postKeyWords_holder: "Please enter the content",
        rules_message_search: "Enter at least one brand or post content",
        my_attention: "MyAttention",
        login_label: "SignIn",
        login_out: "SignOut",
        Chinese: "中文",
        English: "English",
        logo_title: "MOOJING CMI",
        user_cases: "Best-in-Class Use Cases",
    },
    inspiration: {
        // TODO: Title options - 1.Moojing Insight Platform 2.Moojing Market Intelligence 3.Moojing · Consumer BI
        title: "Moojing CMI Platform",
        // TODO: Unified tagline (to be confirmed with user)
        subtitle_unified: "Integrating sales, review & social data — AI-powered consumer & market insight",
        data_products_label: "Data Products",
        // Plan D: data type labels
        data_type_ecommerce: "E-commerce Data",
        data_type_review: "Review Data",
        data_type_social: "Social Media Data",
        data_type_overseas: "Overseas Data",
        data_type_trend: "Trend Discovery",
        // Plan D: AI block
        ai_engine_desc: "Your AI Analytics Copilot",
        // Plan D: comparison table
        compare_traditional: "Traditional Analysis",
        compare_ai: "MoAI Analysis",
        compare_t1: "Switch between multiple platforms",
        compare_t2: "Export data + Excel analysis",
        compare_t3: "Hours to days",
        compare_t4: "Requires professional analysts",
        compare_a1: "One-stop natural language queries",
        compare_a2: "AI auto-integrates and outputs",
        compare_a3: "Minute-level data analysis",
        compare_a4: "Business users can use directly",
        ai_value1: "Deep-thinking CPG business analysis Agent",
        ai_value2: "Natural language interaction, zero learning curve",
        ai_value3: "Multi-source data fusion analysis, traceable",
        comma: ", ",
        unify_sales: "Unifying sales",
        review: "review",
        social: "and social media data for total",
        data_total: "",
        consumer: "",
        and: "",
        market_insight: "",
        subtext: "consumer & market insight (CMI).",
        analysis: "MoAnalysis (Mainland China)",
        comment: "MoListening (Commerce)",
        brand_listen: "MoListening (Social)",
        deepseek_AI: "Power by DeepSeek",
        oversea: "MoAnalysis (Overseas)",
        chance: "MoTrends",
        insight_AI: "MoAI",
        taobao: "Taobao",
        tmall: "Tmall",
        jd: "JD",
        douyin: "Douyin",
        // label_amazon: "Amazon",
        bilibili: "Bilibili",
        social_platforms: "10 Major Social Media Platforms",
        global_E_commerce: "Global E-Commerce Market",
        market_research: "Market Research",
        performance_platforms: "Track sales performance on mainstream Chinese platforms.",
        identify_emerging: "Identify emerging trends with comprehensive product data.",
        define_custom: "Define custom market segments to validate opportunities.",
        analyze_brand: "Analyze brand reputation and pinpoint consumer pain points.",
        benchmark_product: "Benchmark product performance using review data.",
        discover_innovation: "Discover innovation opportunities based on real consumer needs.",
        analyze_product: "Analyze product trends with AI-powered contextual analysis.",
        understand_consumer: "Understand consumer lifestyles, audiences, and usage occasions.",
        optimize_marketing: "Optimize marketing campaigns by tracking topics and influencers.",
        access_comprehensive: "Access comprehensive sales data for the US, Europe, Japan, and more.",
        validate_international: "Validate international market potential with granular filters.",
        leverage_analytics: "Leverage our deep analytics expertise to guide your global strategy.",
        discover_high_growth: "Discover high-growth brands, categories, and concepts—globally.",
        find_blue_ocean: 'Find "blue ocean" opportunities for product innovation.',
        instantly_spot: "Instantly spot emerging trends and hot topics on social media",
        instant_market: "Get instant market analysis, powered by our entire CMI data suite.",
        complex_business: "Ask complex business questions in natural language.",
        generate_comprehensive: "Generate comprehensive industry reports.",
        // TODO: Deprecated keys (kept to avoid reference errors)
        ai_layer_headline: "AI Capability Layer — Intelligent analysis engine powered by CMI data",
        data_layer_desc: "Data Products — Providing comprehensive e-commerce & social data for MoAI",
        get_started: "Get Started",
        ai_get_started: "Try Now",
        try_free: "This product is not yet available for cooperation. You can try it for",
        start_now: "days for free. Would you like to start the trial now",
        yes: "yes",
        no: "no",
        trial_expire:
          "The trial period has expired. If you need to re-activate, please contact the corresponding sales representative for application",
        amazon: "Amazon",
        amazon_us: "Amazon US",
        amazon_de: "Amazon DE",
        amazon_es: "Amazon ES",
        amazon_fr: "Amazon FR",
        amazon_it: "Amazon IT",
        amazon_uk: "Amazon UK",
        amazon_jp: "Amazon JP",
        shopee: "Shopee",
        shopee_vn: "Shopee VN",
        shopee_th: "Shopee TH",
        shopee_sg: "Shopee SG",
        shopee_my: "Shopee MY",
        shopee_ph: "Shopee PH",
        shopee_id: "Shopee ID",
        shopee_tw: "Shopee TW, China",
        lazada: "Lazada",
        lazada_vn: "Lazada VN",
        lazada_th: "Lazada TH",
        lazada_sg: "Lazada SG",
        lazada_my: "Lazada MY",
        lazada_ph: "Lazada PH",
        lazada_id: "Lazada ID",
    },
    inspTh: {
        analyze_name: "Analyze name",
        product_name: "Product name",
        plat: "Plat and cats",
        publish_user: "Publish user",
        publish_time: "Publish time",
        share_count: "Share count",
        operation: "Operation",
    },
    footer: {
      data_E_commerce: "The data is collected and aggregated from public pages. Due to differences in statistical methodologies between us and other institutions, it is for reference only. ",
      data_summarized: "In case of discrepancies, the official data released by the platform shall prevail.",
      company: "Beijing Taomi Technology Limited Co.",
      ICP_number: "LTD. Beijing ICP 15061734-4",
      network_security: "Beijing network security 11010502037832",
    },
};